import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function Benefits() {
  const benefits = ['Cómo crear productos digitales rentables con IA (sin ser experto en tecnología)', 'El sistema exacto para vender en piloto automático', 'Cómo empezar desde cero, aunque no tengas experiencia', 'Las herramientas de IA que hacen todo el trabajo pesado por ti'];
  const notRequired = ['Experiencia previa', 'Conocimientos técnicos', 'Gran inversión inicial'];
  return <section data-id="element-49">
      <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-50">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-10 text-center leading-tight" data-id="element-51">
          En esta masterclass gratuita descubrirás:
        </h2>
        <ul className="space-y-6 mb-16 max-w-3xl mx-auto" data-id="element-52">
          {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-53">
              <CheckIcon className="h-6 w-6 text-green-500 mr-4 flex-shrink-0 mt-1" data-id="element-54" />
              <span className="text-lg md:text-xl leading-relaxed" data-id="element-55">
                {benefit}
              </span>
            </li>)}
        </ul>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-10 text-center leading-tight" data-id="element-56">
          No necesitas:
        </h2>
        <ul className="space-y-6 mb-12 max-w-3xl mx-auto" data-id="element-57">
          {notRequired.map((item, index) => <li key={index} className="flex items-start" data-id="element-58">
              <XIcon className="h-6 w-6 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-59" />
              <span className="text-lg md:text-xl leading-relaxed" data-id="element-60">{item}</span>
            </li>)}
        </ul>
        <p className="text-xl md:text-2xl text-center font-medium leading-relaxed" data-id="element-61">
          Solo necesitas 90 minutos y ganas de aprender.
        </p>
      </div>
    </section>;
}